import React from "react";
import "./contact_homepage.css";

import QRCodeImage from "../../assets/images/ContactSection/QR.png";

const ContactSection = () => {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <h2 className="contact-title">ติดต่อเรา</h2>

        <div className="contact-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d248173.7804886579!2d100.25144379463376!3d13.614191059793512!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e2bd1a820d500b%3A0xdfdb00efc7132dcf!2z4Lia4Lij4Li04Lip4Lix4LiXIDPguIHguK0g4Lit4Li04LiZ4LiX4Li14LmA4Lij4Li14LiiIOC4iOC4s-C4geC4seC4lA!5e0!3m2!1sen!2sth!4v1760926761994!5m2!1sen!2sth"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Maps - 3กอ อินทีเรีย Location"
          />
        </div>
      </div>

      {/* Full-width contact info section */}
      <div className="contact-info-wrapper">
        <div className="contact-info-grid">
          <div className="contact-info-item">
            <h3 className="info-title">โทรศัพท์</h3>
            <p className="info-text">083-9822661</p>
            <p className="info-text">083-9822666</p>
            <p className="info-text">083-9822444</p>
          </div>

          <div className="contact-info-item">
            <h3 className="info-title">Line Official</h3>
            <p className="info-text">@3gorinterior</p>
          </div>

          <div className="contact-info-item">
            <h3 className="info-title">Email</h3>
            <p className="info-text">3gorinterior@gmail.com</p>
          </div>

          <div className="contact-info-item">
            <h3 className="info-title">ที่ตั้งโรงงาน</h3>
            <p className="info-text">
              2/1 Thian Thale 20 Alley, Samae Dam, Bang Khun Thian, Bangkok 10150
            </p>
          </div>

          <div className="contact-info-item">
            <h3 className="info-title">เวลาทำการ</h3>
            <p className="info-text">จันทร์-เสาร์ 8:00-17:00 น.</p>
          </div>

          <div className="contact-info-item">
            <div className="qr-code">
              <img src={QRCodeImage} alt="QR Code สำหรับติดต่อ 3กอ อินทีเรีย" />
            </div>
          </div>
        </div>
      </div>

      {/* Full-width social section */}
      <div className="contact-social-wrapper">
        <div className="contact-social">
          <h3 className="info-title">Facebook</h3>
          <p className="info-text">บริษัท 3กอ อินทีเรีย จำกัด</p>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;